(function () {
  function ready(callback) {
    if (document.readyState !== 'loading') {
      callback();
      return;
    }

    document.addEventListener('DOMContentLoaded', callback);
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function safeJson(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getRootFromElement(element) {
    if (!element) return document.querySelector('[data-cf-discount-root]');
    return element.closest('[data-cf-discount-root]') || document.querySelector('[data-cf-discount-root]');
  }

  function productKey(root, name) {
    return name + ':' + encodeURIComponent(root.dataset.productUrl || window.location.pathname);
  }

  function isSubmitted(root) {
    return sessionStorage.getItem(productKey(root, 'cfDiscountFormSubmitted')) === 'true';
  }

  function saveSubmitted(root) {
    sessionStorage.setItem(productKey(root, 'cfDiscountFormSubmitted'), 'true');
  }

  function getSelectedDiscount(root) {
    return safeJson(sessionStorage.getItem(productKey(root, 'cfSelectedDiscount'))) || null;
  }

  function saveSelectedDiscount(root, data) {
    sessionStorage.setItem(productKey(root, 'cfSelectedDiscount'), JSON.stringify(data));
  }

  function buildDiscountUrl(code, redirectPath) {
    var cleanCode = encodeURIComponent(code || '');
    var cleanRedirect = encodeURIComponent(redirectPath || '/cart');
    return '/discount/' + cleanCode + '?redirect=' + cleanRedirect;
  }

  function copyText(text) {
    if (!text) return Promise.resolve(false);

    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () {
        return true;
      }).catch(function () {
        return fallbackCopy(text);
      });
    }

    return Promise.resolve(fallbackCopy(text));
  }

  function fallbackCopy(text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', 'readonly');
    input.style.position = 'fixed';
    input.style.left = '-9999px';

    document.body.appendChild(input);
    input.select();

    var success = false;

    try {
      success = document.execCommand('copy');
    } catch (error) {
      success = false;
    }

    document.body.removeChild(input);

    return success;
  }

  function setInputValue(input, value) {
    if (!input) return;

    input.value = value || '';
    input.setAttribute('value', value || '');
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fieldMatches(input, label) {
    var wanted = normalize(label);

    var inputText = [
      input.name,
      input.id,
      input.getAttribute('aria-label'),
      input.getAttribute('placeholder'),
      input.getAttribute('data-testid')
    ].map(normalize).join(' ');

    if (inputText.indexOf(wanted) !== -1) return true;

    if (input.id && window.CSS && CSS.escape) {
      var labelElement = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');

      if (labelElement && normalize(labelElement.textContent).indexOf(wanted) !== -1) {
        return true;
      }
    }

    var parent = input.closest('label, div, fieldset');

    if (parent && normalize(parent.textContent).indexOf(wanted) !== -1) {
      return true;
    }

    return false;
  }

  function findFieldByLabel(host, label) {
    if (!host) return null;

    var fields = host.querySelectorAll('input, textarea, select');
    var match = null;

    fields.forEach(function (field) {
      if (match) return;

      if (fieldMatches(field, label)) {
        match = field;
      }
    });

    return match;
  }

  function fillFieldByLabel(host, label, value) {
    var field = findFieldByLabel(host, label);

    if (!field) return false;

    setInputValue(field, value);

    return true;
  }

  function hideFieldByLabel(host, label) {
    var field = findFieldByLabel(host, label);

    if (!field) return false;

    var wrapper =
      field.closest('[data-testid*="field"]') ||
      field.closest('[class*="field"]') ||
      field.closest('label') ||
      field.parentElement;

    if (wrapper) {
      wrapper.classList.add('cf-hidden-tracking-field');
    } else {
      field.classList.add('cf-hidden-tracking-field');
    }

    return true;
  }

  function hideTrackingFields(root) {
    var host = root.querySelector('[data-cf-discount-form-host]');

    if (!host) return;

    [
      'Product Viewed',
      'Product SKU',
      'Product URL',
      'Selected Discount Code',
      'Selected Discount Minimum',
      'Selected Discount Title'
    ].forEach(function (label) {
      hideFieldByLabel(host, label);
    });
  }

  function fillProductTrackingFields(root) {
    var host = root.querySelector('[data-cf-discount-form-host]');

    if (!host) return;

    fillFieldByLabel(host, 'Product Viewed', root.dataset.productTitle);
    fillFieldByLabel(host, 'Product SKU', root.dataset.productSku);
    fillFieldByLabel(host, 'Product URL', root.dataset.productUrl);
  }

  function fillSelectedDiscountFields(root, selectedDiscount) {
    var host = root.querySelector('[data-cf-discount-form-host]');

    if (!host || !selectedDiscount) return;

    fillFieldByLabel(host, 'Selected Discount Code', selectedDiscount.code);
    fillFieldByLabel(host, 'Selected Discount Minimum', selectedDiscount.minimum);
    fillFieldByLabel(host, 'Selected Discount Title', selectedDiscount.title);
  }

  function applyDiscountInBackground(root, code) {
    var frame = root.querySelector('[data-cf-discount-apply-frame]');

    if (!frame || !code) return;

    frame.src = buildDiscountUrl(code, '/cart');
  }

  function successTextFound(root) {
    var host = root.querySelector('[data-cf-discount-form-host]');

    if (!host) return false;

    var text = normalize(host.innerText || host.textContent);

    return (
      text.indexOf('success') !== -1 ||
      text.indexOf('thank you') !== -1 ||
      text.indexOf('the form has been submitted') !== -1 ||
      text.indexOf('form has been submitted') !== -1 ||
      text.indexOf('submitted') !== -1 ||
      text.indexOf('thanks') !== -1 ||
      text.indexOf('you are subscribed') !== -1
    );
  }

  function forceDiscountStep(root) {
    if (!root) return;

    var formStep = root.querySelector('[data-cf-form-step]');
    var offerStep = root.querySelector('[data-cf-offer-step]');
    var footer = root.querySelector('.cf-discount-footer');
    var panel = root.querySelector('.cf-discount-panel');

    saveSubmitted(root);

    root.classList.add('is-form-submitted');
    root.setAttribute('data-form-submitted', 'true');

    if (formStep) {
      formStep.style.display = 'none';
    }

    if (offerStep) {
      offerStep.style.display = 'block';
    }

    if (footer) {
      footer.style.display = 'grid';
    }

    setActionState(root);

    window.setTimeout(function () {
      if (panel && offerStep) {
        panel.scrollTo({
          top: offerStep.offsetTop - 12,
          behavior: 'smooth'
        });
      }
    }, 120);
  }

  function scanForSubmittedForms() {
    document.querySelectorAll('[data-cf-discount-root]').forEach(function (root) {
      fillProductTrackingFields(root);
      hideTrackingFields(root);

      if (isSubmitted(root) || successTextFound(root)) {
        forceDiscountStep(root);
      }
    });
  }

  function updateSelectedUi(root, selectedDiscount) {
    var cards = root.querySelectorAll('[data-cf-discount-card]');
    var selectedText = root.querySelector('[data-cf-discount-selected]');
    var selectedCodeText = root.querySelector('[data-cf-selected-code-text]');

    cards.forEach(function (card) {
      card.classList.toggle('is-selected', Boolean(selectedDiscount && card.dataset.code === selectedDiscount.code));
    });

    if (selectedDiscount && selectedDiscount.code) {
      root.dataset.selectedCode = selectedDiscount.code;
      root.dataset.selectedMinimum = selectedDiscount.minimum || '';
      root.dataset.selectedTitle = selectedDiscount.title || '';

      if (selectedText) selectedText.hidden = false;
      if (selectedCodeText) selectedCodeText.textContent = selectedDiscount.title + ' selected';

      fillSelectedDiscountFields(root, selectedDiscount);
      applyDiscountInBackground(root, selectedDiscount.code);
    } else {
      root.dataset.selectedCode = '';
      root.dataset.selectedMinimum = '';
      root.dataset.selectedTitle = '';

      if (selectedText) selectedText.hidden = true;
      if (selectedCodeText) selectedCodeText.textContent = '';
    }

    setActionState(root);
  }

  function setActionState(root) {
    var selectedDiscount = getSelectedDiscount(root);
    var copyButton = root.querySelector('[data-cf-copy-discount]');
    var applyButton = root.querySelector('[data-cf-apply-discount]');
    var enabled = isSubmitted(root) && selectedDiscount && selectedDiscount.code;

    if (copyButton) copyButton.disabled = !enabled;
    if (applyButton) applyButton.disabled = !enabled;
  }

  function openModal(root) {
    var modal = root.querySelector('[data-cf-discount-modal]');

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('cf-discount-lock');
    document.body.classList.add('cf-discount-modal-open');

    fillProductTrackingFields(root);
    hideTrackingFields(root);

    if (isSubmitted(root) || successTextFound(root)) {
      forceDiscountStep(root);
    }

    var selectedDiscount = getSelectedDiscount(root);

    if (selectedDiscount && selectedDiscount.code) {
      updateSelectedUi(root, selectedDiscount);
    }

    setActionState(root);
  }

  function closeModal(root) {
    var modal = root.querySelector('[data-cf-discount-modal]');

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('cf-discount-lock');
    document.body.classList.remove('cf-discount-modal-open');
  }

  function bindClicks() {
    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-cf-open-discount-modal]');

      if (openButton) {
        event.preventDefault();
        event.stopPropagation();

        var root = document.querySelector('[data-cf-discount-root]');

        if (root) {
          openModal(root);
        }

        return;
      }

      var closeButton = event.target.closest('[data-cf-close-discount]');

      if (closeButton) {
        var closeRoot = getRootFromElement(closeButton);

        if (closeRoot) {
          closeModal(closeRoot);
        }

        return;
      }

      var card = event.target.closest('[data-cf-discount-card]');

      if (card) {
        var cardRoot = getRootFromElement(card);

        if (!cardRoot || !isSubmitted(cardRoot)) return;

        var selectedDiscount = {
          title: card.dataset.title || '',
          code: card.dataset.code || '',
          minimum: card.dataset.minimum || '',
          productTitle: cardRoot.dataset.productTitle || '',
          productSku: cardRoot.dataset.productSku || '',
          productUrl: cardRoot.dataset.productUrl || '',
          productPrice: cardRoot.dataset.productPrice || ''
        };

        saveSelectedDiscount(cardRoot, selectedDiscount);
        updateSelectedUi(cardRoot, selectedDiscount);

        return;
      }

      var copyButton = event.target.closest('[data-cf-copy-discount]');

      if (copyButton) {
        event.preventDefault();

        var copyRoot = getRootFromElement(copyButton);

        if (!copyRoot || !isSubmitted(copyRoot)) return;

        var copyDiscount = getSelectedDiscount(copyRoot);

        if (!copyDiscount || !copyDiscount.code) return;

        copyText(copyDiscount.code).then(function () {
          copyButton.classList.add('is-copied');

          window.setTimeout(function () {
            copyButton.classList.remove('is-copied');
          }, 1200);
        });

        return;
      }

      var applyButton = event.target.closest('[data-cf-apply-discount]');

      if (applyButton) {
        event.preventDefault();

        var applyRoot = getRootFromElement(applyButton);

        if (!applyRoot || !isSubmitted(applyRoot)) return;

        var applyDiscount = getSelectedDiscount(applyRoot);

        if (!applyDiscount || !applyDiscount.code) return;

        copyText(applyDiscount.code);
        applyDiscountInBackground(applyRoot, applyDiscount.code);

        window.location.href = buildDiscountUrl(applyDiscount.code, '/cart');
      }
    }, true);
  }

  function bindFormWatchers() {
    document.addEventListener('submit', function (event) {
      var root = getRootFromElement(event.target);

      if (!root) return;

      fillProductTrackingFields(root);
      hideTrackingFields(root);

      window.setTimeout(scanForSubmittedForms, 400);
      window.setTimeout(scanForSubmittedForms, 900);
      window.setTimeout(scanForSubmittedForms, 1500);
      window.setTimeout(scanForSubmittedForms, 2500);
    }, true);

    document.addEventListener('click', function (event) {
      var submitButton = event.target.closest('button, input[type="submit"]');

      if (!submitButton) return;

      var root = getRootFromElement(submitButton);

      if (!root) return;

      fillProductTrackingFields(root);
      hideTrackingFields(root);

      window.setTimeout(scanForSubmittedForms, 400);
      window.setTimeout(scanForSubmittedForms, 900);
      window.setTimeout(scanForSubmittedForms, 1500);
      window.setTimeout(scanForSubmittedForms, 2500);
    }, true);
  }

  function bindCheckoutRedirect() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest('button, a, input');

      if (!target) return;

      var text = normalize(target.textContent || target.value || target.getAttribute('aria-label'));
      var href = target.getAttribute('href') || '';
      var name = normalize(target.getAttribute('name'));

      var isCheckout =
        text.indexOf('checkout') !== -1 ||
        href.indexOf('/checkout') !== -1 ||
        name === 'checkout';

      if (!isCheckout) return;

      var root = document.querySelector('[data-cf-discount-root]');

      if (!root || !isSubmitted(root)) return;

      var selectedDiscount = getSelectedDiscount(root);

      if (!selectedDiscount || !selectedDiscount.code) return;

      event.preventDefault();

      window.location.href = buildDiscountUrl(selectedDiscount.code, '/checkout');
    }, true);
  }

  function bindMutationWatcher() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      scanForSubmittedForms();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });
  }

  function initRoots() {
    document.querySelectorAll('[data-cf-discount-root]').forEach(function (root) {
      fillProductTrackingFields(root);
      hideTrackingFields(root);

      if (isSubmitted(root) || successTextFound(root)) {
        forceDiscountStep(root);
      }

      var selectedDiscount = getSelectedDiscount(root);

      if (selectedDiscount && selectedDiscount.code) {
        updateSelectedUi(root, selectedDiscount);
      }

      setActionState(root);
    });
  }

  ready(function () {
    bindClicks();
    bindFormWatchers();
    bindCheckoutRedirect();
    bindMutationWatcher();

    initRoots();

    window.setInterval(scanForSubmittedForms, 700);
  });
})();